import StandardLayout from './StandardLayout';
import AdvancedLeftLayout from './AdvancedLeftLayout';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

const Exchange = ({ children, ...props }) => {
  const { selectedLayout } = useSelector((state) => state?.crypto?.layoutReducer);
  
  // Media queries for responsive breakpoints
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ minWidth: 769, maxWidth: 1179 });
  const isLarge = useMediaQuery({ minWidth: 1023 });

  // Always use AdvancedLeftLayout for mobile and tablet screens
  if (isMobile || isTablet) {
    return (
      <AdvancedLeftLayout {...props}>{children}</AdvancedLeftLayout>
    );
  }

  // Use selected layout for large screens
  return selectedLayout === 'Standard' ? (
    <StandardLayout {...props}>{children}</StandardLayout>
  ) : (
    <AdvancedLeftLayout {...props}>{children}</AdvancedLeftLayout>
  );
};

export default Exchange;